import { defineMessages } from 'react-intl';

const translations = {
  previewActions: {
    changeRoute: {
      id: 'orderItemsGrid.previewActions.changeRoute',
      defaultMessage: 'Change route',
      description: 'Label of the change route action in the order items grid preview',
    },
  },
};

export default defineMessages(translations);
